import { Button } from './Button';
import type { ButtonProps } from './Button';
import type { Component } from 'solid-js';

export const ModalButton: Component<ButtonProps> = (props) => (
  <Button class="px-5 py-2 text-xs" variant="outlined" rounded="full" {...props}>
    {props.children}
  </Button>
);
